<script lang="ts">
  import { faFileLines, faArrowRight } from '@fortawesome/free-solid-svg-icons'
  import type { SerializedDocumentBlock } from '../../types'
  import Icon from '../Icon.svelte'

  let { block }: { block: SerializedDocumentBlock } = $props()
</script>

<a class="document-block" href={block.url} download={block.title}>
  <span class="document-block-icon"><Icon icon={faFileLines} /></span>
  <span class="document-block-title">{block.title}</span>
  <span class="document-block-download"><Icon icon={faArrowRight} /></span>
</a>

<style>
  .document-block {
    display: flex;
    align-items: center;
    gap: var(--space-6);
    padding: var(--space-6) var(--space-7);
    margin-bottom: var(--space-9);
    border: var(--border-style-2);
    border-radius: var(--radius-3);
    color: var(--color-text);
    transition: border-color var(--transition-medium);
  }

  .document-block:hover {
    border-color: var(--color-variant-brand);
  }

  .document-block-icon {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: var(--radius-2);
    background-color: var(--color-variant-brand-muted);
    color: var(--color-variant-brand);
    font-size: var(--font-size-5);
  }

  .document-block-title {
    flex: 1;
    font-size: var(--font-size-4);
    font-weight: var(--font-weight-3);
  }

  .document-block-download {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: var(--radius-6);
    background-color: var(--color-bg-muted);
    color: var(--color-text-muted);
    transform: rotate(45deg);

    &:dir(rtl) {
      transform: rotate(-45deg) scaleX(-1);
    }
  }
</style>
